<template>
	<svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28">
		<g id="Group_47657" data-name="Group 47657" transform="translate(0 -14.891)">
			<circle id="Ellipse_856" data-name="Ellipse 856" cx="14" cy="14" r="14" transform="translate(0 14.891)" fill="#5858ec" />
			<path
				id="Path_33008"
				data-name="Path 33008"
				d="M14.137,17.867,11.571,15.2m2.566,2.665L19.1,12.728"
				transform="translate(-1.338 13.872)"
				fill="none"
				stroke="#fff"
				stroke-linecap="round"
				stroke-linejoin="round"
				stroke-width="2"
			/>
		</g>
	</svg>
</template>

<script>
export default {
	name: 'SubflowSuccessSelectedSvg',
};
</script>
